import Amplify from "aws-amplify";
import { cognitoConfig } from "../config/cognitoConfig"
import { isLensEnabledHost } from "../config/lensAvailability";

export function getCallbackUrl(location = window.location) {
  const callbackPath = isLensEnabledHost(location.hostname)
    && (location.pathname === '/lens' || location.pathname.startsWith('/lens/'))
    ? '/lens'
    : '/';
  return `${location.origin}${callbackPath}`;
}

export function initializeAmplify(stage="DEV", region="us-west-2") {
  const callbackUrl = getCallbackUrl();
  const oauth = {
    domain: cognitoConfig[stage][region]["domain"],
    scope: ['openid'],
    redirectSignIn: callbackUrl,
    redirectSignOut: callbackUrl,
    responseType: 'code'
  };

  Amplify.configure({
    Auth: {
      userPoolId: cognitoConfig[stage][region]["userPoolId"],
      userPoolWebClientId: cognitoConfig[stage][region]["userPoolWebClientId"],
      mandatorySignIn: true,
      region: region,
      oauth: oauth
    }
  });
}
